import { render, staticRenderFns } from "./SideBar_Aseguradora.vue?vue&type=template&id=bad5ee88&scoped=true&"
import script from "./SideBar_Aseguradora.vue?vue&type=script&lang=js&"
export * from "./SideBar_Aseguradora.vue?vue&type=script&lang=js&"
import style0 from "./SideBar_Aseguradora.vue?vue&type=style&index=0&id=bad5ee88&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bad5ee88",
  null
  
)

export default component.exports